const state = {
  quotas: [],
  quotaLoading: true,
  visibleQuota: false,
  quotaKeys: null,
};

const getters = {
  quotas(state) {
    return state.quotas;
  },
  quotaLoading(state) {
    return state.quotaLoading;
  },
  visibleQuota(state) {
    return state.visibleQuota;
  },
  quotaKeys(state) {
    return state.quotaKeys;
  },
};

const actions = {
  updateQuotas({ commit }, quotas) {
    commit("UPDATE_QUOTAS", quotas);
  },
  updateQuotaLoading({ commit }, quotaLoading) {
    commit("UPDATE_QUOTA_LOADING", quotaLoading);
  },
  updateVisibleQuota({ commit }, visibleQuota) {
    commit("UPDATE_VISIBLE_QUOTA", visibleQuota);
  },
  updateQuotaKeys({ commit }, quotaKeys) {
    commit("UPDATE_QUOTA_KEYS", quotaKeys);
  },
};

const mutations = {
  UPDATE_QUOTAS(state, quotas) {
    state.quotas = quotas;
  },
  UPDATE_QUOTA_LOADING(state, quotaLoading) {
    state.quotaLoading = quotaLoading;
  },
  UPDATE_VISIBLE_QUOTA(state, visibleQuota) {
    state.visibleQuota = visibleQuota;
  },
  UPDATE_QUOTA_KEYS(state, quotaKeys) {
    state.quotaKeys = quotaKeys;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
